import type { StatLimits, UltimateRequirement } from "../../types";

export const limits: StatLimits = {
  baseHp: 3,
  maxHp: 8,
  baseMp: 1,
  maxMp: null,
  baseWealth: 1,
  maxWealthFromSkills: 4,
  darkOfferingsLimit: 8,
  initialSkillPoints: 3,
  maxSpellLevel: null,
  ultimateWarlock: null,
};

export const ultimateRequirement: UltimateRequirement = {
  kind: "dealings",
  description: "Have had dealings with all 13 Patrons",
};
